var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 13.5H29.7V18.9H24.3V13.5ZM24.3 24.3H29.7V40.5H24.3V24.3ZM27 0C12.096 0 0 12.096 0 27C0 41.904 12.096 54 27 54C41.904 54 54 41.904 54 27C54 12.096 41.904 0 27 0ZM27 48.6C15.093 48.6 5.4 38.907 5.4 27C5.4 15.093 15.093 5.4 27 5.4C38.907 5.4 48.6 15.093 48.6 27C48.6 38.907 38.907 48.6 27 48.6Z",
    fill: "#424242",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleIcon);
export default __webpack_public_path__ + "static/media/InfoCircleIcon.ec8be9cbc19947cf4095f511cdcc1d64.svg";
export { ForwardRef as ReactComponent };